export default {
  TIMEOUT: 1000 * 60,
  HOSTS: {
    MOCK: `${window.location.protocol}//mock.dealmoon.net`,
    ST1: `${window.location.protocol}//biz.st1.dealmoon.net`,
    IT4: `${window.location.protocol}//biz.it4.dealmoon.net`,
    LOCAL: `${window.location.protocol}//localhost:8088` //本地nginx
  }
}



// WEBPACK FOOTER //
// ./src/api/conf.js